/*
 * Copyright (c) 2022. Tooling Team
 */

import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import Accordion from "react-bootstrap/Accordion";
import { Checkbox } from "@uhg-abyss/web/ui/Checkbox";
import { Button } from "@uhg-abyss/web/ui/Button";
import { FormProvider } from "@uhg-abyss/web/ui/FormProvider";
import { IconSymbol } from "@uhg-abyss/web/ui/IconSymbol";
import { useForm } from "@uhg-abyss/web/hooks/useForm";

export function FocusDock(props) {
  const { mapValueTags, handleFocusChange } = props;
  const [tags, setTags] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (
      props.applySavedGridOptions &&
      props.currentFocus &&
      Object.keys(props.currentFocus).length !== 0
    ) {
      setTags(props.currentFocus);
    } else {
      const tags = tagsSchema();
      setTags(tags);
    }
  }, []);

  const tagsSchema = () => {
    const tempTags = {};

    _.sortBy(mapValueTags, "name").map((tag) => {
      tempTags[tag.name] = {};
      tempTags[tag.name].count = 0;
      tempTags[tag.name].values = tag.values.sort().map((val, index) => {
        return {
          id: index,
          name: val,
          selected: false,
        };
      });
    });

    return tempTags;
  };

  const handleChange = (checked, tag, tagType) => {
    const tempTags = { ...tags };
    const filters = {};
    tempTags[tagType].values[tag.id].selected = checked;
    if (checked) {
      tempTags[tagType].count += 1;
    } else {
      tempTags[tagType].count -= 1;
    }
    setTags(tempTags);
    props.setCurrentFocus(tempTags);

    Object.keys(tempTags).forEach((tagType) => {
      const tagObj = tempTags[tagType];
      if (tagObj.count > 0) {
        filters[tagType] = tagObj.values
          .filter((item) => item.selected)
          .map((filteredObj) => filteredObj.name);
      }
    });

    handleFocusChange(filters);
  };

  const resetFocus = () => {
    const tempTags = { ...tags };

    Object.keys(tempTags).forEach((key) => {
      tempTags[key].count = 0;
      tempTags[key].values.map((tag) => {
        tag.selected = false;
      });
    });

    setTags(tempTags);
    props.setCurrentFocus(tempTags);
    handleFocusChange([]);
  };

  const form = useForm();

  const onSubmit = (data) => {
    console.log("submitted", data);
  };

  return (
    <div className={`focus-dock ${open ? "show" : "hide"}`}>
      <div className="focus-dock__menu border d-flex flex-column align-items-stretch">
        <div className="focus-dock__menu-header d-flex border-bottom">
          <h4 className="m-0 me-auto">Focus</h4>
          {open && (
            <IconSymbol
              icon="chevron_left"
              className="icon-link focus-dock__toggle"
              title="Close Focus Dock"
              onClick={() => setOpen(!open)}
            />
          )}
          {!open && (
            <IconSymbol
              icon="chevron_right"
              className="icon-link focus-dock__toggle"
              title="Open Focus Dock"
              onClick={() => setOpen(!open)}
            />
          )}
        </div>
        <div className="focus-dock__filters border-top border-bottom">
          <Accordion flush alwaysOpen defaultActiveKey={[0]}>
            {Object.keys(tags).map((tagType, index) => (
              <Accordion.Item eventKey={index} key={index}>
                <Accordion.Header>
                  {tagType}{" "}
                  <span title={`${tagType} Count`}>
                    {tags[tagType].count ? `(${tags[tagType].count})` : ""}
                  </span>
                </Accordion.Header>
                <Accordion.Body className="focus-dock__filter-panel">
                  <FormProvider
                    className="border-0 p-0"
                    id={`${tagType}-list`}
                    state={form}
                    onSubmit={onSubmit}
                  >
                    {tags[tagType].values.map((tag, index) => {
                      return (
                        <Checkbox
                          key={index}
                          label={tag.name}
                          model={`form-checkbox-${tagType}-${index}`}
                          isChecked={tag.selected}
                          onChange={(e) =>
                            handleChange(e.target.checked, tag, tagType)
                          }
                        />
                      );
                    })}
                  </FormProvider>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
        <div className="focus-dock__menu-footer p-2 mt-auto">
          <Button variant="outline" onClick={resetFocus}>
            Reset Focus
          </Button>
        </div>
      </div>
    </div>
  );
}

FocusDock.propTypes = {
  mapValueTags: PropTypes.array,
  handleFocusChange: PropTypes.func,
  currentFocus: PropTypes.object,
  setCurrentFocus: PropTypes.func,
  applySavedGridOptions: PropTypes.bool,
};
